document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector("product-slider .flickity-slider");
  const goToPreviewSlide = document.querySelector(
    ".flickity-page-dots .dot:nth-child(2)",
  );
  const previewSlide = slider.children[1];
  const input = document.getElementById("custom_name");
  const maxHeight = previewSlide.getBoundingClientRect().height;

  const previewWrapper = document.createElement("div");
  previewWrapper.classList.add("preview-wrapper");
  previewSlide.appendChild(previewWrapper);

  const previewContent = document.createElement("div");
  previewContent.classList.add("preview-content");
  previewWrapper.appendChild(previewContent);

  const previewFirstLetter = document.createElement("div");
  previewFirstLetter.classList.add("preview-first-letter");
  previewContent.appendChild(previewFirstLetter);

  const previewText = document.createElement("span");
  previewText.classList.add("preview-text");
  previewContent.appendChild(previewText);

  const customization = document.getElementById("customization").value;
  const customizationClassName = customization
    .replace(/\s+/g, "-")
    .toLowerCase();
  previewWrapper.classList.add(`image-${customizationClassName}`);
  const isConguitos = customization.toLowerCase().includes("conguitos");

  // Basic a-z letters use a class named after the letter itself.
  const LETTER_CLASSES = [
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m",
    "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z",
  ];

  // Accented letters that have their own SVG. Keys are lowercase (NFC);
  // uppercase input is normalized with toLowerCase() before the lookup.
  const ACCENTED_LETTER_CLASSES = {
    "â": "a-caret",
    "à": "a-grave-accent",
    "ã": "a-tilde",
    "ç": "c-cedilla",
    "ê": "e-caret",
    "ô": "o-caret",
    "õ": "o-tilde",
  };

  const updateEventType = (typeOfEvent) => {
    if (!typeOfEvent) return;

    previewWrapper.classList.remove(
      "evento-cumpleaños",
      "evento-boda",
      "evento-bautizo",
      "evento-comunion",
      "evento-baby-shower",
    );

    switch (typeOfEvent) {
      case "Cumpleaños":
        previewWrapper.classList.add("evento-cumpleaños");
        break;
      case "Boda":
        previewWrapper.classList.add("evento-boda");
        break;
      case "Bautizo":
        previewWrapper.classList.add("evento-bautizo");
        break;
      case "Baby Shower":
        previewWrapper.classList.add("evento-baby-shower");
        break;
      case "1ª Comunión":
        previewWrapper.classList.add("evento-comunion");
    }
  };

  let typeOfEvent = document.querySelector(
    'input[name="Evento"]:checked',
  )?.value;
  updateEventType(typeOfEvent);

  input.addEventListener("input", (event) => {
    goToPreviewSlide.click();

    // Normalize to NFC so accented characters typed as combining sequences
    // (e.g. "a" + "˜") match the precomposed keys in ACCENTED_LETTER_CLASSES.
    const value = event.target.value.normalize("NFC");
    const firstChar = value.charAt(0);
    const lowerFirstChar = firstChar.toLowerCase();
    // Only a-z letters and the accented letters listed above have their own
    // SVG. Numbers and symbols are rendered with the normal typography
    // ("number" class, no SVG).
    const accentedClass = ACCENTED_LETTER_CLASSES[lowerFirstChar];
    const hasLetterSvg = /^[a-zA-Z]$/.test(firstChar) || Boolean(accentedClass);

    previewFirstLetter.classList.remove(
      ...LETTER_CLASSES,
      ...Object.values(ACCENTED_LETTER_CLASSES),
      "number",
    );

    if (hasLetterSvg) {
      previewText.textContent = isConguitos ? value : value.slice(1);
      previewFirstLetter.classList.add(accentedClass || lowerFirstChar);
    } else {
      previewFirstLetter.classList.add("number");
      previewText.textContent = value;
    }

    // Reset scale to measure natural size
    previewContent.style.scale = 1;
    previewWrapper.classList.remove("image-1", "image-2", "image-3", "image-4");

    const previewTextHeight = previewText.getBoundingClientRect().height;
    const availableHeight = maxHeight * 0.45; // Safety margin

    if (previewTextHeight > availableHeight - 50) {
      const scale = availableHeight / previewTextHeight;
      previewContent.style.scale = Math.max(scale, 0.5); // Min 0.5
    } else {
      // Max scale of 1.2 if there is space
      previewContent.style.scale = 1.2;
    }

    const percentSize = Math.min(
      (previewTextHeight / availableHeight) * 100,
      100,
    );

    if (percentSize > 50) {
      previewWrapper.classList.add("image-1");
    } else if (percentSize > 35) {
      previewWrapper.classList.add("image-2");
    } else if (percentSize > 20) {
      previewWrapper.classList.add("image-3");
    } else {
      previewWrapper.classList.add("image-4");
    }
  });

  document.addEventListener("change", (e) => {
    if (e.target.matches('input[name="Evento"]')) {
      typeOfEvent = e.target.value;
      updateEventType(typeOfEvent);
    }
  });
});
